import React from 'react';

import { IconYoutube } from '@prisjakt/ui/icon/youtube';

import { Thumbnail, PlayIconWrapper } from './styles';

export const VideoThumbnail: React.FC<IVideoThumbnail> = props => (
  <Thumbnail className="pj-ui-carousel-video-thumbnail">
    <PlayIconWrapper className="pj-ui-carousel-video-thumbnail--play-icon">
      <IconYoutube />
    </PlayIconWrapper>
    <img src={props.src} alt="" />
  </Thumbnail>
);

interface IVideoThumbnail {
  src: string;
}
